import React from 'react';
import PropTypes from 'prop-types';

import Dialog from '@mui/material/Dialog';
import DialogTitle from '@mui/material/DialogTitle';
import DialogContent from '@mui/material/DialogContent';
import DialogContentText from '@mui/material/DialogContentText';
import DialogActions from '@mui/material/DialogActions';
import { amber } from '@mui/material/colors';
import {styled} from '@mui/system';

import ActionButton from '../component/atoms/ActionButton';


const StyledDefaultMode = styled(DialogTitle)({

});

const StyledWarningMode = styled(DialogTitle)({
    backgroundColor: amber[700]
});

const StyledDialogContentText = styled(DialogContentText)({
    marginTop: 15
});

const StyledDialogActions = styled(DialogActions)({
    marginBottom: 5
});


class ConfirmationDialog extends React.Component {

    constructor(props) {
        super(props);
        this.state = {};

        this.handleClose = this.handleClose.bind(this);
        this.handleConfirm = this.handleConfirm.bind(this);
    }

    handleClose(event) {
        this.props.on_close(event);
    }

    handleConfirm(event) {
        this.props.on_confirm(event);
    }

    dialogActions() {
        if (this.props.on_confirm){
            return (
                <span>
                    <ActionButton text="Cancel" actionCallback={this.handleClose} linkStyle={true} hotKey="alt+x" />
                    <ActionButton text={this.props.dialog_button_text || 'Ok'} dataBt="confirm_button" actionCallback={this.handleConfirm} linkStyle={true} hotKey="alt+o" />
                </span>
            );
        }
        return (
            <ActionButton text={this.props.dialog_button_text || 'Ok'} actionCallback={this.handleClose} linkStyle={true} hotKey="alt+o" />
        );
    }

    render() {
        let StyledDialogMode = this.props.dialog_mode === 'warning' ? StyledWarningMode : StyledDefaultMode;
        return (
            <Dialog
                open={this.props.confirm_dialog_is_open}
                onClose={this.handleClose}
                aria-labelledby="responsive-dialog-title"
            >
                <StyledDialogMode id="responsive-dialog-title">{this.props.dialog_title}</StyledDialogMode>
                <DialogContent>
                    <StyledDialogContentText>
                        {this.props.dialog_text}
                    </StyledDialogContentText>
                </DialogContent>
                <StyledDialogActions>
                    {this.dialogActions()}
                </StyledDialogActions>
            </Dialog>
        );
    }
}


ConfirmationDialog.propTypes = {
    confirm_dialog_is_open: PropTypes.bool,
    on_close: PropTypes.func,
    on_confirm: PropTypes.func,
    dialog_title: PropTypes.string,
    dialog_text: PropTypes.string,
    dialog_button_text: PropTypes.string,
    dialog_mode: PropTypes.string
};

export default ConfirmationDialog;
